import { createFileRoute, Outlet } from "@tanstack/react-router";

import { PurchaseStateContextProvider } from "@/contexts/PurchaseStateContext";
import { SearchDataMissingErrorBoundary } from "@/errors/SearchDataMissingErrorBoundary";
import { FlightFiltersProvider } from "@/features/flights/contexts/FlightFiltersContext";
import { FlightSelectionPayloadProvider } from "@/features/flights/contexts/FlightSelectionPayloadContext/FlightSelectionPayloadContextProvider";
import { useFlightSearchTokens } from "@/features/flights/hooks/useFlightSearchTokens";

export const Route = createFileRoute("/_authenticated/_flights")({
  component: FlightsRoute,
});

function FlightsRoute() {
  return (
    <SearchDataMissingErrorBoundary>
      <RouteComponent />
    </SearchDataMissingErrorBoundary>
  );
}

function RouteComponent() {
  const { query } = useFlightSearchTokens();

  return (
    <FlightFiltersProvider defaultFilters={query.data?.defaultFilters || null}>
      <FlightSelectionPayloadProvider>
        <PurchaseStateContextProvider>
          <Outlet />
        </PurchaseStateContextProvider>
      </FlightSelectionPayloadProvider>
    </FlightFiltersProvider>
  );
}
